import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import type { ScheduleMember } from '@nucleus-commerce/api-client/admin';
import { Input } from '@nucleus-commerce/ui/components/input';

import { MAX_POSITION, MIN_POSITION, parsePosition } from '../lib/position';

/** A member's tie-break position, written when the field loses focus or on Enter. */
export function PositionInput({
  member,
  disabled,
  onCommit,
}: {
  member: ScheduleMember;
  disabled: boolean;
  onCommit: (position: number) => void;
}) {
  const { t } = useTranslation('schedules');
  const [value, setValue] = useState(String(member.position));
  const commit = () => {
    const next = parsePosition(value);
    if (next === null || next === member.position) {
      setValue(String(member.position));
      return;
    }
    setValue(String(next));
    onCommit(next);
  };
  return (
    <Input
      className="h-8 w-20 tabular-nums"
      inputMode="numeric"
      min={MIN_POSITION}
      max={MAX_POSITION}
      value={value}
      disabled={disabled}
      aria-label={t('pool.positionFor', { title: member.product.title })}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => setValue(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          commit();
        }
      }}
    />
  );
}
